import { StateCreator } from "zustand";
import { TableFiltersSliceType } from "./tableFilters.type";
import { addToResetFnsSet } from "../store";

const sliceInitialState = {
  // incident list filters
  incidentTypeFilter: "",
  incidentStatusFilter: "",
  incidentFacilityFilter: "",
  incidentStartDateFilter: "",
  incidentEndDateFilter: "",

  // draft list filters
  draftIncidentTypeFilter: "",
  draftFacilityFilter: "",
  draftStartDateFilter: "",
  draftEndDateFilter: "",

  //   deleted list filters
  deletedIncidentTypeFilter: "",
  deletedIncidentStatusFilter: "",
  deletedIncidentFacilityFilter: "",
  deletedStartDateFilter: "",
  deletedEndDateFilter: "",

  //   global
  debouncedSearchQueryFilter: "",
};

const createTableFiltersSlice: StateCreator<TableFiltersSliceType> = (set) => {
  const reset = () => set(sliceInitialState);
  addToResetFnsSet(reset);
  return {
    ...sliceInitialState,
    setIncidentTypeFilter: (incidentTypeFilter: any) =>
      set(() => {
        return { incidentTypeFilter };
      }),
    setIncidentStatusFilter: (incidentStatusFilter: any) =>
      set(() => {
        return { incidentStatusFilter };
      }),
    setIncidentFacilityFilter: (incidentFacilityFilter: any) =>
      set(() => {
        return { incidentFacilityFilter };
      }),
    setIncidentStartDateFilter: (incidentStartDateFilter: any) =>
      set(() => {
        return { incidentStartDateFilter };
      }),
    setIncidentEndDateFilter: (incidentEndDateFilter: any) =>
      set(() => {
        return { incidentEndDateFilter };
      }),
    setDraftIncidentTypeFilter: (draftIncidentTypeFilter: any) =>
      set(() => {
        return { draftIncidentTypeFilter };
      }),
    setDraftFacilityFilter: (draftFacilityFilter: any) =>
      set(() => {
        return { draftFacilityFilter };
      }),
    setDraftStartDateFilter: (draftStartDateFilter: any) =>
      set(() => {
        return { draftStartDateFilter };
      }),
    setDraftEndDateFilter: (draftEndDateFilter: any) =>
      set(() => {
        return { draftEndDateFilter };
      }),
    setDeletedIncidentTypeFilter: (deletedIncidentTypeFilter: any) =>
      set(() => {
        return { deletedIncidentTypeFilter };
      }),
    setDeletedIncidentStatusFilter: (deletedIncidentStatusFilter: any) =>
      set(() => {
        return { deletedIncidentStatusFilter };
      }),
    setDeletedIncidentFacilityFilter: (deletedIncidentFacilityFilter: any) =>
      set(() => {
        return { deletedIncidentFacilityFilter };
      }),
    setDeletedStartDateFilter: (deletedStartDateFilter: any) =>
      set(() => {
        return { deletedStartDateFilter };
      }),
    setDeletedEndDateFilter: (deletedEndDateFilter: any) =>
      set(() => {
        return { deletedEndDateFilter };
      }),
    setDebouncedSearchQueryFilter: (debouncedSearchQueryFilter: any) =>
      set(() => {
        return { debouncedSearchQueryFilter };
      }),
  };
};

export default createTableFiltersSlice;
